// https://getbootstrap.com/docs/5.0/layout/breakpoints/
export const isMobile = () => typeof window !== 'undefined' ? window && window.document ? window.document.body.clientWidth < 576 : false : false

/** Lightens (positive amount) or darkens (negative) a hex color. */
export function adjustColor(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16)
  const r = Math.min(255, Math.max(0, (num >> 16) + amount))
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0xff) + amount))
  const b = Math.min(255, Math.max(0, (num & 0xff) + amount))
  return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)
}

/** Converts a hex color to its R,G,B components as a comma-separated string
 *  suitable for use in `rgba(var(--school-primary-rgb), 0.1)`. */
export function hexToRgbComponents(hex: string): string {
  const num = parseInt(hex.replace('#', ''), 16)
  const r = (num >> 16) & 0xff
  const g = (num >> 8) & 0xff
  const b = num & 0xff
  return `${r}, ${g}, ${b}`
}

export function cleanGroupName(name: string): string {
  return name
    .replace(/\s*\(All\)\s*/g, ' ')
    .replace(/\s*\(Core\)\s*/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
